import React, { ReactNode } from "react";
import "./ChartWrapper.scss";

interface ChartWrapperProps {
  title: string;
  subTitle?: string;
  children: ReactNode;
}

const ChartWrapper: React.FC<ChartWrapperProps> = ({ title, subTitle, children }) => {
  return (
    <div className="chart-wrapper">
      <div className="chart-wrapper__title">
        <span>{title}</span>
      </div>
      <div className="chart-wrapper__sub-title">
        <span>{subTitle}</span>
      </div>
      <div className="chart-wrapper__content">{children}</div>
    </div>
  );
};

export default ChartWrapper;
